
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/prototyping",
      function () {
        return require("private-next-pages/download/prototyping/index.tsx");
      }
    ]);
  